import React from "react";

const Background: React.FC = () => (
  <div className="fixed inset-0 w-full h-screen z-0">
    {/* Top half - Blue gradient with wavy lines */}
    <div className="absolute top-0 left-0 w-full" style={{ height: "33.333vh" }}>
      {/* Gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700"></div>
      {/* Wavy lines on top */}
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <svg className="w-full h-full" preserveAspectRatio="xMidYMid slice">
          <defs>
            <pattern
              id="wavy-lines"
              width="120"
              height="80"
              patternUnits="userSpaceOnUse"
            >
              <path
                d="M0,20 Q30,10 60,20 T120,20"
                fill="none"
                stroke="white"
                strokeWidth="1.5"
                opacity="0.8"
              />
              <path
                d="M0,40 Q30,30 60,40 T120,40"
                fill="none"
                stroke="white"
                strokeWidth="1"
                opacity="0.6"
              />
              <path
                d="M0,60 Q30,50 60,60 T120,60"
                fill="none"
                stroke="white"
                strokeWidth="1.5"
                opacity="0.8"
              />
              <path
                d="M30,0 Q20,20 30,40 T30,80"
                fill="none"
                stroke="white"
                strokeWidth="1"
                opacity="0.5"
              />
              <path
                d="M90,0 Q80,20 90,40 T90,80"
                fill="none"
                stroke="white"
                strokeWidth="1"
                opacity="0.5"
              />
            </pattern>
          </defs>
          <rect
            x="0"
            y="0"
            width="100%"
            height="100%"
            fill="url(#wavy-lines)"
          />
        </svg>
      </div>
    </div>

    {/* Bottom half - Light blue color */}
    <div
      className="absolute bottom-0 left-0 w-full"
      style={{ height: "66.667vh", backgroundColor: "#EAF3FA" }}
    ></div>
  </div>
);

export default Background;
